import { useEffectOnce } from 'react-use'
import { Link, Navigate } from 'react-router-dom'

import { ReactComponent as Check } from 'assets/images/icon-check.svg'
import { ResetPasswordTitle } from '../ResetPasswordTitle/ResetPasswordTitle'
import './ResetPassStage3.scss'

interface Props {
  timeLeft: number
  startTimer: () => void
}

export const ResetPassStage3 = ({ timeLeft, startTimer }: Props) => {
  useEffectOnce(() => {
    startTimer()
  })

  return (
    <>
      {timeLeft === 0 && <Navigate replace to='/login' />}
      <div className='c-reset-pass-stage-3__checkmark-container'>
        <Check className='c-reset-pass-stage-3__checkmark-check' />
      </div>
      <ResetPasswordTitle>Password Updated</ResetPasswordTitle>

      <p className='c-reset-pass-stage-3__succes-info'>
        Password successfully changed. In <b>{timeLeft} seconds</b> you’ll be automatically logged in.
      </p>
      <p className='c-reset-pass-stage-3__succes-info'>
        If nothing happens, please <Link to='/login'>click here</Link>.
      </p>
    </>
  )
}
